export default __webpack_public_path__ + "static/media/circle-checkmark-solid.a744507f.svg";